export const formatFecha = (fecha) => {
  if (!fecha) return "";
  return new Date(fecha).toLocaleDateString("es-MX", {
    day: "2-digit", month: "short", year: "numeric"
  });
};

export const formatDinero = (cantidad) => {
  if (!cantidad) return "$0";
  return new Intl.NumberFormat("es-MX", {
    style: "currency", currency: "MXN", minimumFractionDigits: 0
  }).format(cantidad);
};

function primeraLetraNombre(token) {
  const s = String(token || "").trim();
  for (let i = 0; i < s.length; i += 1) {
    const ch = s[i];
    if (/[A-Za-zÀ-ÿ\u00f1\u00d1]/.test(ch)) {
      return ch.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase();
    }
  }
  return "";
}

/** Dos iniciales: nombre + 1.er apellido (2.ª palabra). Si solo hay nombre, nombre + última letra. */
export function inicialesNombreApellido(nombre) {
  const parts = String(nombre || "").trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  const iniNombre = primeraLetraNombre(parts[0]);
  if (!iniNombre) return "?";
  if (parts.length >= 2) {
    const iniApellido = primeraLetraNombre(parts[1]);
    return iniApellido ? `${iniNombre}${iniApellido}` : iniNombre;
  }
  const word = parts[0];
  let iniUltima = iniNombre;
  for (let i = word.length - 1; i >= 0; i -= 1) {
    if (/[A-Za-zÀ-ÿ\u00f1\u00d1]/.test(word[i])) {
      iniUltima = word[i].normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase();
      break;
    }
  }
  return `${iniNombre}${iniUltima}`;
}

export const iniciales = inicialesNombreApellido;

/** Etiqueta en KPIs circulares: nombre + 1.er apellido; Ana → "Ana". */
export function etiquetaKpiAgente(nombre) {
  const parts = String(nombre || "").trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  if (/^ana$/i.test(parts[0])) return "Ana";
  return inicialesNombreApellido(nombre);
}

/** Convierte errores de API (string u objeto) en texto legible para alertas. */
export function formatApiError(err, fallback = "Error desconocido") {
  const raw =
    err?.response?.data?.error ??
    err?.response?.data?.message ??
    err?.error ??
    err?.message ??
    err;
  if (raw == null || raw === "") return fallback;
  if (typeof raw === "string") return raw;
  if (typeof raw.message === "string") return raw.message;
  if (typeof raw.error === "string") return raw.error;
  try {
    return JSON.stringify(raw);
  } catch {
    return fallback;
  }
}
